/**
 * Outbound links to community/project resources, kept in one place so the same
 * URL doesn't drift between the places that offer it.
 */

/** community Discord, offered in the about dialog and the diagnostics panel */
export const DISCORD_INVITE_URL = "https://discord.gg/QPyEATsbP7";
